import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {RuleContainerModel} from "../../../../../../../models/aggregates/alg/cc/rule";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
  
@Injectable({providedIn: "root"})
export class RuleService extends BaseApiTemplateService<RuleContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'rules';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'rules';
    this.httpClient = http;
  }
}